import WhatsappButton from 'components/WhatsappButton'
import React from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import Login from './Login'
import NewPassword from './NewPassword'

const PublicRoutes = () => (
  <Router>
    <Switch>
      <Route exact path={['/', '/login']} component={Login} />
      <Route path='/redefine-password' component={NewPassword} />
      <Redirect to='/login' />
    </Switch>
  </Router>
)

const PartnerRoutes = () => {
  return (
    <>
      <PublicRoutes />
      <WhatsappButton />
    </>
  )
}

export default PartnerRoutes
